import {
  Component,
  ElementRef,
  AfterViewChecked,
  ViewChild,
  Input,
  Output,
  EventEmitter,
} from "@angular/core";
import { AppConfig } from "src/app/configs/app.config";
import { CommonService } from "src/app/core/services/common.service";

@Component({
  selector: "app-conversation",
  templateUrl: "./conversation.component.html",
  styleUrls: ["./conversation.component.scss"],
})
export class ConversationComponent implements AfterViewChecked {

  @ViewChild("conversationContainer", { static: true })
  conversationContainer: ElementRef<HTMLDivElement>;

  @Input() messages: [];
  @Input() isTyping: boolean;
  @Input() isShowPrompt: boolean;

  @Output() promptState = new EventEmitter<string>();
  @Output() navigateTo = new EventEmitter<number>();
  readonly imgPath: string;

  queryNavigator = [
    { value: 'main', label: 'Go to Main Content' },
    { value: 'previous', label: 'visit previous query'}
  ]

  constructor(private commonService: CommonService) {
    this.imgPath = AppConfig.POPUP_LOGO;
  }

  getDataType(message) {
    return typeof message;
  }

  ngAfterViewChecked(): void {
    const calculatedTop =
      this.conversationContainer.nativeElement.scrollHeight -
      this.conversationContainer.nativeElement.clientHeight;
    if (calculatedTop != this.conversationContainer.nativeElement.scrollTop)
      this.conversationContainer.nativeElement.scrollTop = calculatedTop;
  }

  showPrompt() {
    this.promptState.emit();
  }

  getQuery(index) {
    this.navigateTo.emit(index);
  }

  proceed(query, queryType: "category" | "question") {
    this.commonService.setSelectedQueryFromUser({
      query: queryType == "category" ? query : query.question,
      queryId: queryType == "category" ? null : query.id,
      queryType: queryType,
    });
  }
}
